import { ComponentConfig, DropZone } from '@measured/puck';
import {
  flexDirections,
  boxShadows,
} from '../../../../page-builder/puck/reusable-props/options';
import './styles.scss';
import {
  GapProps,
  gapField,
} from '../../../../page-builder/puck/reusable-props/gap';
import showComponent, {
  showComponentProps,
} from '../../../puck/reusable-props/showComponent';
import {
  paddingFields,
  PaddingProps,
} from '../../../../page-builder/puck/reusable-props/padding';
import {
  marginFields,
  MarginProps,
} from '../../../../page-builder/puck/reusable-props/margin';
import CustomTooltip from '../../../../components/common/tooltip';
import { ReduxSelectorProps } from '../../../services/constants';
import {
  getBorderProps,
  getcurrentDeviceType,
  getMarginStyles,
  getPaddingStyles,
  resolveShowComponentField,
} from '../../../utils/helper';
import Border, {
  borderProps,
  IBorderValueProps,
} from '../../../puck/reusable-props/Border';
import { backgroungFields } from '../../../puck/reusable-props/backgroungFields';

export type FlexProps = {
  items: { minItemSize?: number }[];
  minItemSize: number;
  background: {
    color: string;
    isInherit: boolean;
  };
  flexDirection: 'row' | 'column' | 'row-reverse' | 'column-reverse';
  boxShadow: 'none' | 'shadow-md' | 'shadow-lg' | 'shadow-xl' | 'shadow-2xl';
  border: IBorderValueProps;
} & PaddingProps &
  GapProps &
  showComponentProps &
  MarginProps;
export const Flex = ({
  useAppSelector,
}: ReduxSelectorProps): ComponentConfig<FlexProps> => {
  return {
    label: (
      <CustomTooltip title="Flex">
        <span>Flex</span>
      </CustomTooltip>
    ) as React.ReactNode as string,
    fields: {
      ...showComponent,
      ...paddingFields,
      ...marginFields,
      border: {
        type: 'custom',
        render: ({ value, onChange }) => (
          <Border
            value={value}
            onChange={onChange}
            title="Border"
            showWidthProps={true}
          />
        ),
      },
      ...backgroungFields,
      items: {
        label: 'Items',
        type: 'array',
        arrayFields: {
          minItemSize: {
            label: 'Minimum Item Width/Height',
            type: 'number',
            min: 0,
          },
        },
        getItemSummary: (_, id) => `Item ${Number(id) + 1}`,
      },
      flexDirection: {
        label: 'Direction',
        type: 'select',
        options: flexDirections,
      },
      ...gapField,
      boxShadow: {
        label: 'Shadow',
        type: 'select',
        options: boxShadows,
      },
      minItemSize: {
        label: 'Minimum Item Width/Height',
        type: 'number',
        min: 0,
      },
    },
    defaultProps: {
      showComponent: ['desktop', 'tablet', 'mobile'],
      items: [{}, {}],
      minItemSize: 0,
      flexDirection: 'row',
      gap: 'gap-2',
      boxShadow: 'none',
      padding: {
        deviceType: 'desktop',
        paddingBottom: {
          desktop: '0',
          mobile: '0',
          tablet: '0',
        },
        paddingLeft: {
          desktop: '0',
          mobile: '0',
          tablet: '0',
        },
        paddingRight: {
          desktop: '0',
          mobile: '0',
          tablet: '0',
        },
        paddingTop: {
          desktop: '0',
          mobile: '0',
          tablet: '0',
        },
      },
      margin: {
        desktop: {
          top: '0',
          bottom: '0',
          right: '0',
          left: '0',
        },
        tablet: {
          top: '0',
          bottom: '0',
          right: '0',
          left: '0',
        },
        mobile: {
          top: '0',
          bottom: '0',
          right: '0',
          left: '0',
        },
      },
      ...borderProps,
      background: {
        color: '#ffffff',
        isInherit: false,
      },
    },
    resolveFields: ({ props }, { fields }) =>
      resolveShowComponentField(props.id, fields),
    render: ({
      items,
      minItemSize,
      flexDirection,
      padding,
      gap,
      margin,
      border,
      boxShadow,
      background,
      showComponent,
      editMode,
    }) => {
      const windowWidth = useAppSelector(state => state.store.currentWidth);
      const currentDeviceType = getcurrentDeviceType(windowWidth, editMode);
      const marginStyles = getMarginStyles(margin, currentDeviceType);
      return (
        <div
          className={`flex ${gap} ${boxShadow} ${showComponent?.includes(currentDeviceType) ? '' : '!hidden'}  ${border?.borderStyle?.[currentDeviceType]}`}
          style={{
            flexDirection,
            backgroundColor: background?.isInherit
              ? 'inherit'
              : background?.color,
            ...marginStyles,
            ...getBorderProps(border, currentDeviceType, true),
            ...getPaddingStyles(padding, currentDeviceType),
          }}>
          {items.map((item, idx) => (
            <div
              key={idx}
              className={'Flex-item'}
              style={
                flexDirection === 'row' || flexDirection === 'row-reverse'
                  ? { minWidth: item.minItemSize || minItemSize }
                  : { minHeight: item.minItemSize || minItemSize }
              }>
              <DropZone zone={`item-${idx}`} />
            </div>
          ))}
        </div>
      );
    },
  };
};
